import { APP_CONSTANT } from '../constants/AppConstants';
import properties from 'properties';
import AppUtil from 'js/utils/AppUtil';
import AppHelper from 'js/app/AppHelper';
import { APP_URL_CONSTANTS } from 'js/common/constants/GlobalConstants';
import { updateIssueCollectorConfig } from 'js/modules/issue/actions/IssueConfigActions';

export const initAppComp = () => {
    return dispatch => {
        //reducer funct pupulate
        dispatch({
            type: APP_CONSTANT.INIT_APP
        })
    }
}

export const showLoading = () => {
    return {
        type: APP_CONSTANT.SHOW_LOADING
    }
}

export const hideLoading = () => {
    return {
        type: APP_CONSTANT.HIDE_LOADING
    }
}

export const populateIssueLinstingData = data => {
    return {
        type: APP_CONSTANT.LOAD_ISSUE_LISTING,
        payload: {
            data
        }
    }
}

/* istanbul ignore next */
export const getIssueListing = issueList => {
    return dispatch => {
        if ( !issueList ) {
            const url = properties.isIntegrated ? properties.url + APP_URL_CONSTANTS.READ_ISSUE_COLLECTOR_LIST + 
                "/" + AppHelper.getParamData('icentid') + "/" + AppHelper.getAppData('projectId') +
                "/" + AppHelper.getParamData('sologinid') : "ewrf/data/IssueList.json";

            AppUtil.ajax(url, undefined, response => {
                dispatch( populateIssueLinstingData( response ) );
            });
        }
    }
}

export const setHeaderHeight = height => {
    return {
        type: APP_CONSTANT.SET_HEADER_HEIGHT,
        height
    }
}

export const changeHomePage = pageName => {
    return {
        type: APP_CONSTANT.CHANGE_HOME_PAGE,
        pageName
    }
}

export const addIssueCollectorInListing = issuecollector => {
    return {
        type: APP_CONSTANT.ADD_ISSUE_COLLECTOR_IN_LISTING,
        issuecollector
    }
}

export const updateICInListing = config => {
    return {
        type: APP_CONSTANT.UPDATE_IC_IN_LISTING,
        config
    }
}

export const deleteIssueCollector = id => {
    return {
        type: APP_CONSTANT.DELETE_ISSUE_COLLECTOR,
        id
    }
}

/* istanbul ignore next */
export const deleteIC = id => {
    return dispatch => {
        const url = properties.url + APP_URL_CONSTANTS.DELETE_ISSUE_COLLECTOR_URL + "/" + id + "/" +
        AppHelper.getParamData('sologinid');

        AppUtil.ajax(url, undefined, () => {
            dispatch( deleteIssueCollector( id ) );
        }, undefined, undefined, undefined, false);
    }
}

export const changeICStatusInListing = (id, status) => {
    return {
        type: APP_CONSTANT.CHANGE_ISSUE_COLLECTOR_STATUS,
        id,
        status
    }
}

/* istanbul ignore next */
export const changeIssueCollectorStatus = (id, status, updateIcCondfig) => {
    return dispatch => {
        const url = properties.url + APP_URL_CONSTANTS.CHANGE_ISSUE_COLLECTOR__STATUS_URL + "/" + id + "/" + status +
        "/" + AppHelper.getParamData('sologinid');

        AppUtil.ajax(url, undefined, () => {
            dispatch( changeICStatusInListing( id, status ) );
            
            if (updateIcCondfig) {
                dispatch( updateIssueCollectorConfig( {
                    status
                } ) );
            }
        }, undefined, undefined, undefined, false);
    }
}

export const openCardTypeSettings = () => {
    return {
        type: APP_CONSTANT.OPEN_CARDTYPE_SETTINGS
    }
}

export const closeCardTypeSettings = () => {
    return {
        type: APP_CONSTANT.CLOSE_CARDTYPE_SETTINGS
    }
}

export const openOutlookSettings = pluginType => {
    return {
        type: APP_CONSTANT.OPEN_OUTLOOK_SETTINGS,
        pluginType
    }
}

export const closeOutlookSettings = () => {
    return {
        type: APP_CONSTANT.CLOSE_OUTLOOK_SETTINGS
    }
}

export const toggleMoreInstruction = () => {
    return {
        type: APP_CONSTANT.TOGGLE_MORE_INSTRUCTION
    }
}